import axios from "axios";
import { FORM_ASYNC_API_URL } from "../../utils/constants";

// The Query Tool lives in forms-async-api, not the registration backend, so a
// heavy query cannot slow that service down. The auth header is set globally by
// utils/setAuthToken; that service verifies the same back-office token and
// checks for the "Query Tool" role.
const BASE = `${FORM_ASYNC_API_URL}/query-tool`;

// Tables panel: names and columns to write the SQL against.
export const getSchemaApi = (refresh = false) =>
    axios.get(`${BASE}/schema`, { params: refresh ? { refresh: true } : {} }).then((res) => res.data);

// --- Export to GCP -------------------------------------------------------
// Query results are never returned to the browser. An export writes them to an
// encrypted file in the bucket and emails the link and the key.

export const createExportApi = (sql, recipients, name) =>
    axios.post(`${BASE}/export`, { sql, recipients, name }).then((res) => res.data);

export const listExportsApi = (limit = 20) =>
    axios.get(`${BASE}/exports`, { params: { limit } }).then((res) => res.data);

export const getExportLinkApi = (exportId) =>
    axios.get(`${BASE}/exports/${exportId}/link`).then((res) => res.data);

export const getExportKeyApi = (exportId) =>
    axios.get(`${BASE}/exports/${exportId}/key`).then((res) => res.data);

export const cancelExportApi = (exportId) =>
    axios.post(`${BASE}/exports/${exportId}/cancel`).then((res) => res.data);

// Emails a finished export's link and key to more addresses; the query is not run again.
export const addExportRecipientsApi = (exportId, recipients) =>
    axios.post(`${BASE}/exports/${exportId}/recipients`, { recipients }).then((res) => res.data);
